import rpc from '@square/dashboard-utilities/clients/rpc';
import { FlagsService } from '@square/ember-features/protos/squareup/feature/relay/flags/service';
export const GET_FLAGS_URL = '/1.0/features/get-flags';
export const GET_FLAGS_SANDBOX_URL = '/1.0/features/get-flags-sandbox';
const HEADERS = new Map();
function urlForMethod(method, guessedUrl) {
  switch (method) {
    case FlagsService.methods.GetFlags:
      return GET_FLAGS_URL;
    case FlagsService.methods.GetFlagsSandbox:
      return GET_FLAGS_SANDBOX_URL;
    default:
      return guessedUrl;
  }
}
export default FlagsService.create(rpc(urlForMethod, {
  additionalHeaders: HEADERS
}));